export default {
    cancelled: 'CANCELLED',
    completed: 'COMPLETED',
    inProgress: 'IN_PROGRESS',
    notStarted: 'NOT_STARTED',
    missed: 'MISSED',
};
